import { render, staticRenderFns } from "./Ayarlar.vue?vue&type=template&id=1d9bf4dd&"
import script from "./Ayarlar.vue?vue&type=script&lang=js&"
export * from "./Ayarlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports